import React from "react";
import { Star, Quote } from "lucide-react";
import PageHero from "../components/PageHero";
import { Section } from "../components/SectionPrimitives";
import CTABand from "../components/CTABand";

const testimonials = [
  {
    name: "Carlos Henrique",
    role: "Empresário — Construção Civil",
    text: "Aumentamos significativamente nossos contatos através do Google. Excelente atendimento, equipe muito atenciosa e que entende profundamente o nosso negócio.",
    accent: "#4285F4",
  },
  {
    name: "Fernanda Souza",
    role: "Diretora — Clínica Odontológica",
    text: "Profissionais extremamente competentes. Nosso site ficou incrível e os agendamentos aumentaram em 3x desde que começamos a trabalhar com a O.G.",
    accent: "#EA4335",
  },
  {
    name: "Rafael Oliveira",
    role: "Sócio — Escritório de Advocacia",
    text: "Resultado acima das expectativas. As campanhas de Google Ads trouxeram clientes qualificados todos os dias. Hoje somos referência na nossa área e na cidade.",
    accent: "#FBBC05",
  },
  {
    name: "Juliana Martins",
    role: "Proprietária — Imobiliária",
    text: "Equipe comprometida e transparente. Sempre mostrando melhorias e resultados — sentimos uma parceria de verdade, não um simples fornecedor.",
    accent: "#34A853",
  },
  {
    name: "Marcelo Andrade",
    role: "CEO — E-commerce de moda",
    text: "Triplicamos o faturamento em menos de seis meses com a gestão da O.G. nas campanhas de Meta Ads. Recomendo fortemente.",
    accent: "#4285F4",
  },
  {
    name: "Patrícia Lima",
    role: "Gerente — Restaurante Premium",
    text: "Atendimento humano, reuniões mensais bem estruturadas e total transparência nos relatórios. Profissionalismo do início ao fim.",
    accent: "#EA4335",
  },
];

export default function Avaliacoes() {
  return (
    <div data-testid="page-avaliacoes">
      <PageHero
        breadcrumb="Avaliações"
        eyebrow="Resultados Reais"
        title="O que dizem"
        highlight="nossos clientes."
        subtitle="A confiança de mais de 100 empresas que crescem com a O.G. Marketing Digital. Veja relatos reais de quem está colhendo resultados."
      />

      <Section testId="avaliacoes-grid">
        <div className="flex items-center gap-6 mb-12">
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((s) => (
              <Star key={s} size={24} className="fill-[#FBBC05] text-[#FBBC05]" />
            ))}
          </div>
          <div className="border-l border-gray-200 pl-6">
            <p className="font-display text-4xl font-bold text-[#000000]">
              5.0/5
            </p>
            <p className="text-sm text-[#000000]/60">Média de satisfação</p>
          </div>
          <div className="hidden sm:block border-l border-gray-200 pl-6">
            <p className="font-display text-4xl font-bold text-[#000000]">+100</p>
            <p className="text-sm text-[#000000]/60">Clientes ativos</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <article
              key={t.name}
              data-testid={`avaliacao-${i}`}
              className="og-card relative"
              style={{ borderTop: `3px solid ${t.accent}` }}
            >
              <Quote size={28} style={{ color: t.accent }} className="opacity-30" />
              <div className="flex gap-1 mt-4">
                {[1, 2, 3, 4, 5].map((s) => (
                  <Star
                    key={s}
                    size={14}
                    className="fill-[#FBBC05] text-[#FBBC05]"
                  />
                ))}
              </div>
              <p className="mt-4 text-[#000000]/80 leading-relaxed">
                {`"${t.text}"`}
              </p>
              <div className="mt-6 pt-4 border-t border-gray-100">
                <p className="font-display font-bold text-[#000000]">{t.name}</p>
                <p className="text-xs text-[#000000]/60 mt-1">{t.role}</p>
              </div>
            </article>
          ))}
        </div>
      </Section>

      <CTABand
        title="Quer ser nosso próximo case de sucesso?"
        subtitle="Solicite uma análise gratuita e descubra quanto sua empresa pode crescer."
        whatsappMsg="Olá! Vi as avaliações e gostaria de uma análise gratuita."
      />
    </div>
  );
}
